/**
 * 缓存说明:抄表系统业主管理
 */
import vm from '@/cache/storeTools.js'

var basestate = {
    workorder: {},
}

var store = new vm.Vuex.Store({
    state: copy(basestate),
    getters: {

    },
    mutations: {
        clear() {
            //清理缓存
            store.replaceState(copy(basestate))
        },
        setWorkorder(state, item) {
            vm.Vue.set(state, 'workorder', item)
        },
    }
});

//对外提供
export default store